export default __webpack_public_path__ + "static/media/logodark.50a5a058.png";